// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"97a945da","856":"21d705b8"}[chunkId] + ".chunk.js";
};